import React from "react";

function FileName({ name, maxLength = 20 }) {
  const truncateMiddleFilename = () => {
    if (name.length <= maxLength) {
      return name;
    }

    const ellipsis = "...";
    const ellipsisLength = ellipsis.length;

    const charsToRemove = name.length - maxLength + ellipsisLength;
    const charsBeforeEllipsis = Math.ceil((name.length - charsToRemove) / 2);
    const charsAfterEllipsis =
      name.length - charsToRemove - charsBeforeEllipsis;

    return (
      name.substring(0, charsBeforeEllipsis) +
      ellipsis +
      name.substring(name.length - charsAfterEllipsis)
    );
  };

  const truncatedFilename = truncateMiddleFilename();

  return <span>{truncatedFilename}</span>;
}

export default FileName;
